/*
 * MilAura : PDP calendrier de l'Avent, 2026-10-17.
 * Logique pure, testée sous Node par tests/milaura-calendrier-contract.test.mjs,
 * puis câblage de la façade des cases dans le navigateur.
 */
(function (root) {
  'use strict';

  var FAMILLES = ['bijou', 'roulee', 'mineral', 'pochette'];
  var TOLERANCE = 0.01;

  function expandItems(items) {
    var objets = [];
    (items || []).forEach(function (item) {
      var quantite = Number(item && item.quantity) || 0;
      var libelle = item && item.label ? item.label : null;
      var decoupes = item && Array.isArray(item.crops) ? item.crops : [];
      for (var i = 0; i < quantite; i += 1) objets.push({ family: item.family, label: libelle, crop: decoupes[i] || null });
    });
    return objets;
  }

  function nombre(valeur) {
    return typeof valeur === 'number' && isFinite(valeur);
  }

  // Rectangle en pourcentage, arrondi à deux décimales : bornes tolérées à 0,01 près.
  function rectangleValide(rect) {
    if (!rect || !nombre(rect.x) || !nombre(rect.y) || !nombre(rect.w) || !nombre(rect.h)) return false;
    return (
      rect.x >= -TOLERANCE &&
      rect.y >= -TOLERANCE &&
      rect.w > 0 &&
      rect.h > 0 &&
      rect.x + rect.w <= 100 + TOLERANCE &&
      rect.y + rect.h <= 100 + TOLERANCE
    );
  }

  function erreursFacade(details, cases) {
    var erreurs = [];
    if (details.windows == null && details.facade_crop == null) return erreurs;
    if (!rectangleValide(details.facade_crop)) erreurs.push('facade_crop absent ou hors de C01');
    if (!Array.isArray(details.windows) || details.windows.length !== cases) {
      erreurs.push('windows doit compter case_count fenêtres');
      return erreurs;
    }
    var vus = {};
    details.windows.forEach(function (fenetre, index) {
      var n = fenetre && fenetre.n;
      if (!Number.isInteger(n) || n < 1 || n > cases) erreurs.push('numéro invalide, fenêtre ' + (index + 1));
      else if (vus[n]) erreurs.push('numéro ' + n + ' en double, fenêtre ' + (index + 1));
      else vus[n] = true;
      if (!rectangleValide(fenetre)) erreurs.push('fenêtre ' + (index + 1) + ' hors de la face');
    });
    return erreurs;
  }

  function erreursDecoupes(items) {
    var erreurs = [];
    var avecDecoupes = items.filter(function (item) {
      return item && item.crops != null;
    }).length;
    if (!avecDecoupes) return erreurs;
    if (avecDecoupes !== items.length) erreurs.push('crops sur toutes les lignes ou sur aucune');
    items.forEach(function (item, index) {
      if (!item || item.crops == null) return;
      if (!Array.isArray(item.crops) || item.crops.length !== Number(item.quantity)) {
        erreurs.push('crops doit compter quantity rectangles, ligne ' + (index + 1));
        return;
      }
      item.crops.forEach(function (rect, rang) {
        if (!rectangleValide(rect)) erreurs.push('découpe ' + (rang + 1) + ' hors de C04, ligne ' + (index + 1));
      });
    });
    return erreurs;
  }

  function validateDetails(details) {
    if (!details || typeof details !== 'object') return ['données absentes'];
    var erreurs = [];
    var cases = Number(details.case_count);
    if (details.schema_version !== 2) erreurs.push('schema_version doit valoir 2');
    if (typeof details.case_count !== 'number' || !Number.isInteger(cases) || cases < 1) erreurs.push('case_count doit être un entier');
    ['short_name', 'composition_summary'].forEach(function (champ) {
      if (typeof details[champ] !== 'string' || !details[champ].trim()) erreurs.push(champ + ' absent');
    });
    if (details.content_variability !== 'fixe' && details.content_variability !== 'variable') {
      erreurs.push('content_variability doit valoir fixe ou variable');
    }
    if (!Array.isArray(details.items) || !details.items.length) {
      erreurs.push('items absent');
      return erreurs;
    }
    var total = 0;
    details.items.forEach(function (item, index) {
      var quantite = Number(item && item.quantity);
      if (!item || FAMILLES.indexOf(item.family) === -1) erreurs.push('famille inconnue, ligne ' + (index + 1));
      if (!Number.isInteger(quantite) || quantite < 1) erreurs.push('quantité invalide, ligne ' + (index + 1));
      else total += quantite;
    });
    if (total !== cases) erreurs.push('somme des quantités (' + total + ') différente de case_count (' + cases + ')');
    return erreurs.concat(erreursFacade(details, cases), erreursDecoupes(details.items));
  }

  function createDraw(size, random) {
    var hasard = typeof random === 'function' ? random : Math.random;
    var reste = [];
    function reset() {
      reste = [];
      for (var i = 0; i < size; i += 1) reste.push(i);
      for (var j = reste.length - 1; j > 0; j -= 1) {
        var k = Math.floor(hasard() * (j + 1));
        var echange = reste[j];
        reste[j] = reste[k];
        reste[k] = echange;
      }
    }
    reset();
    return {
      next: function () {
        return reste.length ? reste.pop() : null;
      },
      remaining: function () {
        return reste.length;
      },
      reset: reset
    };
  }

  function displayLabel(item, generiques) {
    if (item && item.label) return item.label;
    return (item && generiques && generiques[item.family]) || '';
  }

  // Une fenêtre, donnée en % de la face, exprimée en % de C01.
  function rectFenetre(faceCrop, fenetre) {
    return {
      x: faceCrop.x + (fenetre.x * faceCrop.w) / 100,
      y: faceCrop.y + (fenetre.y * faceCrop.h) / 100,
      w: (fenetre.w * faceCrop.w) / 100,
      h: (fenetre.h * faceCrop.h) / 100
    };
  }

  // Rectangle de C04 centré sur la découpe, au rapport de la boîte (largeur / hauteur) :
  // la découpe occupe `remplissage` de la boîte dans sa dimension limitante.
  function rectObjet(crop, boxRatio, imageRatio, remplissage) {
    var largeur;
    var hauteur;
    if ((crop.w * imageRatio) / crop.h >= boxRatio) {
      largeur = crop.w / remplissage;
      hauteur = (largeur * imageRatio) / boxRatio;
    } else {
      hauteur = crop.h / remplissage;
      largeur = (hauteur * boxRatio) / imageRatio;
    }
    return { x: crop.x + crop.w / 2 - largeur / 2, y: crop.y + crop.h / 2 - hauteur / 2, w: largeur, h: hauteur };
  }

  // Position en % d'une <img> absolue, dans une boîte overflow: hidden, pour que rect la remplisse.
  function cadre(rect) {
    return { width: 10000 / rect.w, height: 10000 / rect.h, left: (-100 * rect.x) / rect.w, top: (-100 * rect.y) / rect.h };
  }

  function vagueDelai(fenetre, pas) {
    return Math.round((fenetre.x + fenetre.y) / 10) * pas;
  }

  function joursRestants(isoLimite, aujourdhui) {
    var morceaux = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(isoLimite || '').trim());
    if (!morceaux) return null;
    var limite = new Date(Number(morceaux[1]), Number(morceaux[2]) - 1, Number(morceaux[3]));
    var jour = aujourdhui instanceof Date ? aujourdhui : new Date();
    var debut = new Date(jour.getFullYear(), jour.getMonth(), jour.getDate());
    var jours = Math.round((limite - debut) / 86400000);
    return jours >= 0 ? jours : null;
  }

  function remplir(modele, valeurs) {
    return String(modele || '').replace(/\[(\w+)\]/g, function (marque, cle) {
      return cle in valeurs ? valeurs[cle] : marque;
    });
  }

  function publier(nom, donnees) {
    var shopify = root && root.Shopify;
    if (!shopify || !shopify.analytics || typeof shopify.analytics.publish !== 'function') return;
    try {
      shopify.analytics.publish(nom, donnees);
    } catch (erreur) {
      // La mesure ne doit jamais bloquer la page.
    }
  }

  var DUREE_PORTE = 800;
  var REMPLISSAGE = 0.84;

  function rectDe(element) {
    var d = (element && element.dataset) || {};
    return { x: Number(d.x), y: Number(d.y), w: Number(d.w), h: Number(d.h) };
  }

  function placer(image, rect) {
    var position = cadre(rect);
    image.style.width = position.width + '%';
    image.style.height = position.height + '%';
    image.style.left = position.left + '%';
    image.style.top = position.top + '%';
    return image;
  }

  function initCases(section, options) {
    var reglages = options || {};
    if (!section || section.dataset.calendrierPret === 'true') return null;
    var source = section.querySelector('[data-calendrier-donnees]');
    var facade = section.querySelector('[data-calendrier-facade]');
    var donnees;
    try {
      donnees = JSON.parse(source ? source.textContent : '');
    } catch (erreur) {
      return null;
    }
    var objets = expandItems(donnees.items);
    var cases = Array.prototype.slice.call(section.querySelectorAll('[data-calendrier-case]'));
    if (!facade || !objets.length || objets.length !== cases.length) return null;

    section.dataset.calendrierPret = 'true';
    section.classList.add('js-calendrier');
    var planifier = reglages.planifier || function (action, delai) {
      root.setTimeout(action, delai);
    };
    var creer = reglages.creer || function (balise) {
      return root.document.createElement(balise);
    };
    var tirage = createDraw(objets.length, reglages.random);
    var textes = donnees.textes || {};
    var contenu = donnees.contenu && donnees.contenu.url ? donnees.contenu : null;
    var face = rectDe(facade);
    var rapportFace = Number(facade.dataset.ratio) || 1;
    var photo = section.querySelector('.milaura-calendrier-facade__photo');
    var revelePhoto = section.querySelector('[data-calendrier-revele-photo]');
    var nomEl = section.querySelector('[data-calendrier-revele-nom]');
    var surtitreEl = section.querySelector('[data-calendrier-revele-surtitre]');
    var note = section.querySelector('[data-calendrier-revele-note]');
    var compteur = section.querySelector('[data-calendrier-compteur]');
    var complet = section.querySelector('[data-calendrier-complet]');
    var surprise = section.querySelector('[data-calendrier-surprise]');
    var referme = section.querySelector('[data-calendrier-referme]');
    var entrouverte = Number(section.dataset.entrouverte) || 0;
    var ouvertes = 0;
    var generation = 0;
    var precharge = false;

    function image(src) {
      var img = creer('img');
      img.alt = '';
      img.src = src;
      return img;
    }

    // Chaque porte montre le morceau exact de C01, dans la taille déjà choisie par le navigateur.
    function habillerPortes() {
      var src = photo && (photo.currentSrc || photo.src);
      if (!src) return;
      cases.forEach(function (bouton) {
        var morceau = bouton.querySelector('[data-calendrier-porte-face]');
        if (morceau) morceau.replaceChildren(placer(image(src), rectFenetre(face, rectDe(bouton))));
      });
      facade.classList.add('is-prete');
    }

    function prechargerContenu() {
      if (precharge || !contenu) return;
      precharge = true;
      image(contenu.url);
    }

    // L'objet découpé sur C04, inséré sans attendre son chargement : le fond blanc l'attend.
    function objetDans(boite, objet, rapportBoite) {
      if (!boite) return false;
      if (!contenu || !objet.crop) {
        boite.replaceChildren();
        return false;
      }
      boite.replaceChildren(placer(image(contenu.url), rectObjet(objet.crop, rapportBoite, Number(contenu.ratio) || 1, REMPLISSAGE)));
      return true;
    }

    function majCompteur() {
      if (!compteur) return;
      var modele = ouvertes >= objets.length ? textes.tout : ouvertes > 1 ? textes.plusieurs : textes.un;
      compteur.textContent = remplir(modele, { n: ouvertes, total: objets.length });
    }

    function marquer(bouton, objet) {
      var libelle = displayLabel(objet, donnees.generiques);
      var fenetre = rectDe(bouton);
      cases.forEach(function (autre) {
        autre.classList.remove('is-entrouverte');
      });
      bouton.classList.add('is-ouverte');
      bouton._objet = objet;
      bouton.setAttribute('aria-label', remplir(textes.case_ouverte, { numero: bouton.dataset.numero, libelle: libelle }));
      objetDans(bouton.querySelector('[data-calendrier-cavite]'), objet, (fenetre.w * rapportFace) / fenetre.h);
      return libelle;
    }

    function apresOuverture() {
      majCompteur();
      section.classList.add('a-ouvert');
      if (surprise) surprise.hidden = false;
      if (referme) referme.textContent = '';
    }

    // La révélation : photo de l'objet si sa découpe existe, libellé, et l'origine de la photo seulement avec elle.
    function montrer(objet) {
      var avecPhoto = revelePhoto ? objetDans(revelePhoto, objet, 1) : false;
      if (revelePhoto) revelePhoto.hidden = !avecPhoto;
      if (note) note.hidden = !avecPhoto;
      // Une pierre roulée nommée n'a que son nom (« Améthyste ») : sa famille s'écrit au-dessus.
      if (surtitreEl) {
        var surtitre = objet && objet.family === 'roulee' && objet.label ? donnees.surtitre_roulee || '' : '';
        surtitreEl.textContent = surtitre;
        surtitreEl.hidden = !surtitre;
      }
      if (nomEl) {
        nomEl.hidden = false;
        nomEl.classList.remove('is-vide', 'is-nouveau');
        nomEl.textContent = displayLabel(objet, donnees.generiques);
        void nomEl.offsetWidth;
        nomEl.classList.add('is-nouveau');
      }
    }

    function ouvrir(bouton) {
      if (bouton.classList.contains('is-ouverte')) {
        if (bouton._objet) montrer(bouton._objet);
        return;
      }
      var index = tirage.next();
      if (index === null) return;
      prechargerContenu();
      var objet = objets[index];
      marquer(bouton, objet);
      ouvertes += 1;
      montrer(objet);
      apresOuverture();
      publier('milaura_calendrier_case_ouverte', { ouverture: ouvertes });
    }

    function toutOuvrir() {
      var vague = generation;
      prechargerContenu();
      section.classList.add('a-tout');
      cases.forEach(function (bouton) {
        if (bouton.classList.contains('is-ouverte')) return;
        var index = tirage.next();
        if (index === null) return;
        planifier(function () {
          if (vague === generation) marquer(bouton, objets[index]);
        }, reglages.reduit ? 0 : vagueDelai(rectDe(bouton), 45));
      });
      ouvertes = objets.length;
      if (revelePhoto) revelePhoto.hidden = true;
      if (surtitreEl) surtitreEl.hidden = true;
      if (nomEl) nomEl.hidden = true;
      if (note) note.hidden = true;
      apresOuverture();
      publier('milaura_calendrier_contenu_complet', {});
    }

    function refermer() {
      generation += 1;
      cases.forEach(function (bouton, position) {
        bouton.classList.remove('is-ouverte');
        bouton._objet = null;
        bouton.classList.toggle('is-entrouverte', position + 1 === entrouverte);
        bouton.setAttribute('aria-label', bouton.dataset.labelFerme);
      });
      // Les objets restent visibles pendant que les portes se referment, puis les cases se vident.
      planifier(function () {
        cases.forEach(function (bouton) {
          var interieur = bouton.querySelector('[data-calendrier-cavite]');
          if (interieur && !bouton.classList.contains('is-ouverte')) interieur.replaceChildren();
        });
      }, reglages.reduit ? 0 : DUREE_PORTE);
      tirage.reset();
      ouvertes = 0;
      if (complet) complet.open = false;
      if (revelePhoto) {
        revelePhoto.hidden = true;
        revelePhoto.replaceChildren();
      }
      if (surtitreEl) surtitreEl.hidden = true;
      if (note) note.hidden = true;
      if (nomEl) {
        nomEl.hidden = false;
        nomEl.textContent = textes.consigne || '';
        nomEl.classList.add('is-vide');
      }
      majCompteur();
      section.classList.remove('a-ouvert', 'a-tout');
      if (surprise) surprise.hidden = true;
      if (referme) referme.textContent = referme.getAttribute('data-texte') || '';
      if (cases[0]) cases[0].focus();
    }

    cases.forEach(function (bouton) {
      bouton.dataset.labelFerme = bouton.getAttribute('aria-label');
      bouton.addEventListener('click', function () {
        ouvrir(bouton);
      });
    });
    if (photo) {
      if (photo.complete && (photo.currentSrc || photo.src)) habillerPortes();
      else photo.addEventListener('load', habillerPortes);
    }
    if (contenu && root.IntersectionObserver) {
      var guet = new root.IntersectionObserver(
        function (entrees) {
          if (!entrees.some(function (entree) { return entree.isIntersecting; })) return;
          guet.disconnect();
          prechargerContenu();
        },
        { rootMargin: '200px' }
      );
      guet.observe(facade);
    }
    if (complet) {
      complet.addEventListener('toggle', function () {
        section.classList.toggle('a-tout', complet.open);
        if (complet.open && ouvertes < objets.length) toutOuvrir();
      });
    }
    if (surprise) surprise.addEventListener('click', refermer);
    return { ouvrir: ouvrir, toutOuvrir: toutOuvrir, refermer: refermer };
  }

  function initDelai(element, aujourdhui) {
    if (!element) return;
    var jours = joursRestants(element.getAttribute('data-limite'), aujourdhui);
    if (jours === null) {
      element.dataset.expire = 'true';
      element.hidden = true;
      return;
    }
    var cible = element.querySelector('[data-calendrier-jours]');
    var modele = jours === 0 ? 'data-texte-dernier' : jours === 1 ? 'data-texte-jour' : 'data-texte-jours';
    if (cible) cible.textContent = remplir(element.getAttribute(modele), { n: jours });
  }

  function initVariantes(doc) {
    doc.addEventListener('milaura:pdp-variant', function (event) {
      var detail = (event && event.detail) || {};
      var option = doc.querySelector('[data-pdp-variant-select] option[value="' + detail.id + '"]');
      doc.querySelectorAll('[data-calendrier-delai]').forEach(function (delai) {
        delai.hidden = !detail.available || delai.dataset.expire === 'true';
      });
      doc.querySelectorAll('[data-calendrier-stock]').forEach(function (stock) {
        var texte = option ? option.dataset.stockTexte : '';
        if (texte) stock.textContent = texte;
        stock.hidden = !detail.available || (option ? !texte : stock.hidden);
      });
    });
  }

  function observateurDe(options) {
    return options && 'Observer' in options ? options.Observer : root.IntersectionObserver;
  }

  // Attend l'approche de l'élément : la photo principale passe d'abord.
  function quandProche(element, action, options) {
    var Observateur = observateurDe(options);
    if (!Observateur || !element) {
      action();
      return;
    }
    var fait = false;
    var observateur = new Observateur(function (entrees) {
      if (fait || !entrees.some(function (entree) { return entree.isIntersecting; })) return;
      fait = true;
      observateur.disconnect();
      action();
    }, { rootMargin: (options && options.marge) || '600px 0px' });
    observateur.observe(element);
  }

  function chargerVignette(image) {
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;
  }

  // La vignette sans image est masquée : on observe son cadre, à taille fixe.
  function initVignettes(doc, options) {
    doc.querySelectorAll('[data-calendrier-vignette]').forEach(function (image) {
      quandProche(image.parentNode || image, function () {
        chargerVignette(image);
      }, { Observer: observateurDe(options), marge: '300px 0px' });
    });
  }

  var api = {
    FAMILLES: FAMILLES,
    expandItems: expandItems,
    validateDetails: validateDetails,
    createDraw: createDraw,
    displayLabel: displayLabel,
    rectFenetre: rectFenetre,
    rectObjet: rectObjet,
    cadre: cadre,
    vagueDelai: vagueDelai,
    joursRestants: joursRestants,
    initCases: initCases,
    initDelai: initDelai,
    initVariantes: initVariantes,
    quandProche: quandProche,
    initVignettes: initVignettes
  };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }
  if (root.MilauraCalendrier) return;
  root.MilauraCalendrier = api;

  function initAll(scope) {
    var racine = scope || root.document;
    var reduit = Boolean(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches);
    racine.querySelectorAll('[data-milaura-calendrier-cases]').forEach(function (section) {
      quandProche(section, function () {
        initCases(section, { reduit: reduit });
      });
    });
    racine.querySelectorAll('[data-calendrier-delai]').forEach(function (element) {
      initDelai(element, new Date());
    });
    initVignettes(racine);
  }

  initVariantes(root.document);
  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
  root.document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})(typeof window !== 'undefined' ? window : this);
